// Copyright (c) 2022 by Move Closer

import { Data } from '@vue/composition-api'

import { CanBeDisabled, CanHaveTheme, DoubleClick, HasSize, HasVariant } from '../../composables'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl> (original)
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl> (edited)
 */
export interface ButtonProps extends CanBeDisabled, CanHaveTheme, Data, DoubleClick, HasSize, HasVariant {
  /**
   * Text shown to the User when he clicks the button for the 1st time.
   * In use only when the `doubleClick` prop is set to `true`.
   * @see ButtonProps.doubleClick
   */
  confirmationLabel?: string

  /**
   * Show label on small screen
   */
  hideLabelOnMobile: boolean

  /**
   * Determines whether button is on full width.
   */
  isFluid: boolean

  /**
   * Determines whether the component should display a isLoading indicator.
   */
  isLoading: boolean

  /**
   * Button's label.
   */
  label: string
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export enum Theme {
  Danger = 'danger',
  Link = 'link', // TODO: This shouldn't be here.
  Outline = 'outline', // FIXME: This shouldn't be here but we need also changes in backoffice
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum Variant {
  Full = 'full',
  Outline = 'outline'
}
